import { useArbeitszeiten } from '@/domain/arbeitszeiten/hooks';
import Uebersicht from '@/domain/arbeitszeiten/pages/uebersicht/Uebersicht';
import UebersichtLoading from '@/domain/arbeitszeiten/pages/uebersicht/UebersichtLoading';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { WithLocationGuard } from '@/features/locationGuard/WithLocationGuard';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { buildLink } from '@/utils';
import { Suspense, useMemo } from 'react';
import { useParams } from 'react-router-dom';

export function UebersichtWrapper() {
  const { year, month, day } = useParams();
  const date = useMemo(
    () => new Date(`${year}-${month}-${day}`),
    [year, month, day],
  );
  const { currentStandort } = useStandortContext();
  const arbeitszeiten = useArbeitszeiten(date, currentStandort.id);
  if (arbeitszeiten.loading) {
    return (
      <WithLocationGuard
        countries={['DE']}
        fallbackURL={buildLink('arbeitszeiten')}>
        <WithFeatureFlags name="arbeitszeiten">
          <UebersichtLoading />
        </WithFeatureFlags>
      </WithLocationGuard>
    );
  }
  return (
    <WithLocationGuard
      countries={['DE']}
      fallbackURL={buildLink('arbeitszeiten')}>
      <WithFeatureFlags name="arbeitszeiten">
        <Suspense fallback={<UebersichtLoading />}>
          <Uebersicht arbeitszeiten={arbeitszeiten} />
        </Suspense>
      </WithFeatureFlags>
    </WithLocationGuard>
  );
}
